document.addEventListener('DOMContentLoaded', function () {
  const roots = document.querySelectorAll('[data-bhtu]');

  roots.forEach((root) => {
    initHowToUse(root);
  });

  document.addEventListener('shopify:section:load', function (event) {
    const container = event.target;
    if (!container) return;
    const root = container.querySelector('[data-bhtu]');
    if (root) initHowToUse(root);
  });

  function initHowToUse(root) {
    initNavCarousel(root);
    initStepsScrollbars(root);
    initFilters(root);
    initVideos(root);
    initFaq(root);
  }

  function initNavCarousel(root) {
    const nav = root.querySelector('[data-bhtu-nav]');
    const prev = root.querySelector('[data-bhtu-nav-prev]');
    const next = root.querySelector('[data-bhtu-nav-next]');

    if (!nav || !prev || !next) return;
    if (nav.dataset.carouselBound === 'true') return;
    nav.dataset.carouselBound = 'true';

    const cards = Array.from(nav.querySelectorAll('.bhtu__nav-card'));
    if (!cards.length) return;

    let currentPage = 0;

    const getPageSize = () => {
      if (window.matchMedia('(max-width: 749px)').matches) return 2;
      if (window.matchMedia('(max-width: 1199px)').matches) return 3;
      return 4;
    };

    const getPageCount = () => {
      const pageSize = getPageSize();
      return Math.max(1, Math.ceil(cards.length / pageSize));
    };

    const renderPage = () => {
      const pageSize = getPageSize();
      const pageCount = getPageCount();

      if (currentPage > pageCount - 1) {
        currentPage = pageCount - 1;
      }
      if (currentPage < 0) {
        currentPage = 0;
      }

      const start = currentPage * pageSize;
      const end = start + pageSize;

      cards.forEach((card, index) => {
        const isVisible = index >= start && index < end;
        card.hidden = !isVisible;
        card.setAttribute('aria-hidden', isVisible ? 'false' : 'true');
      });

      prev.disabled = currentPage === 0;
      next.disabled = currentPage >= pageCount - 1;
    };

    const revealPageForKey = (key) => {
      if (!key) return;

      const targetIndex = cards.findIndex((card) => card.dataset.bhtuFilter === key);
      if (targetIndex < 0) return;

      currentPage = Math.floor(targetIndex / getPageSize());
      renderPage();
    };

    prev.addEventListener('click', () => {
      if (currentPage <= 0) return;
      currentPage -= 1;
      renderPage();
    });

    next.addEventListener('click', () => {
      const pageCount = getPageCount();
      if (currentPage >= pageCount - 1) return;
      currentPage += 1;
      renderPage();
    });

    root.addEventListener('bhtu:nav-reveal', (event) => {
      const key = event.detail && event.detail.key ? event.detail.key : '';
      revealPageForKey(key);
    });

    window.addEventListener('resize', () => {
      const activeCard = cards.find((card) => card.classList.contains('is-active'));
      if (activeCard) {
        revealPageForKey(activeCard.dataset.bhtuFilter);
      } else {
        renderPage();
      }
    });

    const initialActiveCard = cards.find((card) => card.classList.contains('is-active'));
    if (initialActiveCard) {
      revealPageForKey(initialActiveCard.dataset.bhtuFilter);
    } else {
      renderPage();
    }
  }

  function initFilters(root) {
    const nav = root.querySelector('[data-bhtu-nav]');
    if (!nav) return;

    const buttons = Array.from(nav.querySelectorAll('[data-bhtu-filter]'));
    const groups = Array.from(root.querySelectorAll('[data-bhtu-group]'));

    if (!buttons.length || !groups.length) return;

    const normalizeKey = (value) => String(value || '').trim().toLowerCase();

    const getRequestedKeyFromUrl = () => {
      const url = new URL(window.location.href);
      const requested = normalizeKey(url.searchParams.get('product'));
      if (!requested) return '';

      const match = buttons.find((button) => normalizeKey(button.dataset.bhtuFilter) === requested);
      return match ? requested : '';
    };

    const syncUrl = (key) => {
      const url = new URL(window.location.href);
      url.searchParams.set('product', key);
      window.history.replaceState({}, '', `${url.pathname}${url.search}${url.hash}`);
    };

    const syncActiveSteps = (key) => {
      const targetGroup = root.querySelector(`[data-bhtu-group="${key}"]`);
      if (!targetGroup) return;

      targetGroup.querySelectorAll('[data-bhtu-steps-slider]').forEach((slider) => {
        slider.dispatchEvent(new CustomEvent('bhtu:steps-update'));
      });
    };

    const syncActiveFaqHeights = (key) => {
      const targetGroup = root.querySelector(`[data-bhtu-group="${key}"]`);
      if (!targetGroup) return;

      targetGroup.querySelectorAll('[data-bhtu-faq]').forEach((faq) => {
        faq.dispatchEvent(new CustomEvent('bhtu:sync-heights'));
      });
    };

    const revealActiveButtonPage = (key) => {
      root.dispatchEvent(
        new CustomEvent('bhtu:nav-reveal', {
          detail: { key }
        })
      );
    };

    const pauseInactiveVideos = (key) => {
      groups.forEach((group) => {
        const isActive = group.dataset.bhtuGroup === key;
        const videos = group.querySelectorAll('.bhtu__video-el');

        videos.forEach((video) => {
          const wrap = video.closest('.bhtu__video');
          if (!wrap) return;

          if (!isActive) {
            if (wrap._bhtuHideTimer) {
              clearTimeout(wrap._bhtuHideTimer);
              wrap._bhtuHideTimer = null;
            }

            video.pause();
            wrap.classList.remove('is-playing', 'is-ui-hidden');

            const button = wrap.querySelector('.bhtu__video-toggle');
            if (button) {
              button.setAttribute('aria-label', 'Play video');
            }
          }
        });
      });
    };

    const setActive = (key, options = {}) => {
      const opts = {
        syncUrl: false,
        scrollToGroup: false,
        ...options
      };

      buttons.forEach((button) => {
        button.classList.toggle('is-active', button.dataset.bhtuFilter === key);
      });

      groups.forEach((group) => {
        group.classList.toggle('is-active', group.dataset.bhtuGroup === key);
      });

      pauseInactiveVideos(key);

      if (opts.syncUrl) {
        syncUrl(key);
      }

      requestAnimationFrame(() => {
        revealActiveButtonPage(key);
        syncActiveSteps(key);
        syncActiveFaqHeights(key);

        if (opts.scrollToGroup) {
          const targetGroup = root.querySelector(`[data-bhtu-group="${key}"]`);
          if (targetGroup) {
            const top = targetGroup.getBoundingClientRect().top + window.scrollY - 120;
            window.scrollTo({ top, behavior: 'smooth' });
          }
        }
      });
    };

    const requestedKey = getRequestedKeyFromUrl();
    const initialButton =
      (requestedKey && buttons.find((button) => normalizeKey(button.dataset.bhtuFilter) === requestedKey)) ||
      buttons.find((button) => button.classList.contains('is-active')) ||
      buttons[0];

    if (initialButton) {
      setActive(initialButton.dataset.bhtuFilter);
    }

    buttons.forEach((button) => {
      if (button.dataset.bound === 'true') return;
      button.dataset.bound = 'true';

      button.addEventListener('click', () => {
        const key = button.dataset.bhtuFilter;
        setActive(key, {
          syncUrl: true,
          scrollToGroup: true
        });
      });
    });
  }

  function initStepsScrollbars(root) {
    const sliders = root.querySelectorAll('[data-bhtu-steps-slider]');
    const isMobile = () => window.matchMedia('(max-width: 749px)').matches;
    const clamp = (n, min, max) => Math.max(min, Math.min(max, n));

    sliders.forEach((slider) => {
      if (slider.dataset.bound === 'true') return;
      slider.dataset.bound = 'true';

      const stepsTrack = slider.querySelector('[data-bhtu-steps-track]');
      const scrollbar = slider.querySelector('[data-bhtu-steps-scrollbar]');
      const track = slider.querySelector('[data-bhtu-steps-scrollbar-track]');
      const thumb = slider.querySelector('[data-bhtu-steps-scrollbar-thumb]');

      if (!stepsTrack || !scrollbar || !track || !thumb) return;

      const showScrollbar = () => {
        scrollbar.classList.add('is-visible');
        scrollbar.style.setProperty('display', 'block', 'important');
        scrollbar.style.setProperty('opacity', '1', 'important');
        scrollbar.style.setProperty('visibility', 'visible', 'important');
        scrollbar.style.setProperty('pointer-events', 'auto', 'important');
      };

      const hideScrollbar = () => {
        scrollbar.classList.remove('is-visible');
        scrollbar.style.setProperty('display', 'none', 'important');
        scrollbar.style.setProperty('opacity', '0', 'important');
        scrollbar.style.setProperty('visibility', 'hidden', 'important');
        scrollbar.style.setProperty('pointer-events', 'none', 'important');
        thumb.style.left = '0px';
      };

      const updateScrollbar = () => {
        if (isMobile()) {
          hideScrollbar();
          return;
        }

        const scrollWidth = stepsTrack.scrollWidth;
        const clientWidth = stepsTrack.clientWidth;
        const maxScroll = Math.max(0, scrollWidth - clientWidth);
        const trackWidth = track.clientWidth || clientWidth;

        if (trackWidth <= 0 || clientWidth <= 0) return;

        if (maxScroll <= 1) {
          hideScrollbar();
          return;
        }

        showScrollbar();

        const ratio = clientWidth / Math.max(scrollWidth, 1);
        const thumbWidth = Math.max(180, trackWidth * ratio);
        const finalThumbWidth = Math.min(trackWidth, thumbWidth);

        thumb.style.width = `${finalThumbWidth}px`;

        const maxLeft = Math.max(0, trackWidth - finalThumbWidth);
        const progress = maxScroll <= 0 ? 0 : stepsTrack.scrollLeft / maxScroll;
        thumb.style.left = `${progress * maxLeft}px`;
      };

      const syncScrollFromThumbLeft = (newLeft) => {
        const trackWidth = track.clientWidth;
        const thumbWidth = thumb.offsetWidth;
        const maxLeft = Math.max(0, trackWidth - thumbWidth);

        const clampedLeft = clamp(newLeft, 0, maxLeft);
        thumb.style.left = `${clampedLeft}px`;

        const maxScroll = Math.max(0, stepsTrack.scrollWidth - stepsTrack.clientWidth);
        stepsTrack.scrollLeft = maxLeft <= 0 ? 0 : (clampedLeft / maxLeft) * maxScroll;
      };

      let panning = false;
      let panStartX = 0;
      let panStartScrollLeft = 0;
      let didDrag = false;
      const DRAG_THRESHOLD = 6;

      const isInteractiveTarget = (target) => {
        return !!target.closest('a, button, input, select, textarea, label, [role="button"]');
      };

      stepsTrack.addEventListener(
        'pointerdown',
        (e) => {
          if (isMobile()) return;
          if (isInteractiveTarget(e.target)) return;
          if (stepsTrack.scrollWidth <= stepsTrack.clientWidth + 1) return;

          panning = true;
          didDrag = false;
          panStartX = e.clientX;
          panStartScrollLeft = stepsTrack.scrollLeft;
          stepsTrack.classList.add('is-dragging');
          stepsTrack.setPointerCapture(e.pointerId);
          e.preventDefault();
        },
        { passive: false }
      );

      stepsTrack.addEventListener('pointermove', (e) => {
        if (!panning) return;

        const dx = e.clientX - panStartX;
        if (Math.abs(dx) > DRAG_THRESHOLD) didDrag = true;
        stepsTrack.scrollLeft = panStartScrollLeft - dx;
      });

      stepsTrack.addEventListener('pointerup', (e) => {
        panning = false;
        if (stepsTrack.hasPointerCapture?.(e.pointerId)) {
          stepsTrack.releasePointerCapture(e.pointerId);
        }
        requestAnimationFrame(() => stepsTrack.classList.remove('is-dragging'));
      });

      stepsTrack.addEventListener('pointercancel', (e) => {
        panning = false;
        if (stepsTrack.hasPointerCapture?.(e.pointerId)) {
          stepsTrack.releasePointerCapture(e.pointerId);
        }
        stepsTrack.classList.remove('is-dragging');
      });

      stepsTrack.addEventListener(
        'click',
        (e) => {
          if (!didDrag) return;

          if (e.target.closest('a') || e.target.closest('button')) {
            e.preventDefault();
            e.stopPropagation();
          }

          didDrag = false;
        },
        true
      );

      stepsTrack.addEventListener('scroll', () => requestAnimationFrame(updateScrollbar));
      window.addEventListener('resize', () => requestAnimationFrame(updateScrollbar));

      let draggingThumb = false;
      let thumbStartX = 0;
      let thumbStartLeft = 0;

      thumb.addEventListener('pointerdown', (e) => {
        if (stepsTrack.scrollWidth <= stepsTrack.clientWidth + 1) return;

        draggingThumb = true;
        thumbStartX = e.clientX;
        thumbStartLeft = parseFloat(getComputedStyle(thumb).left) || 0;
        thumb.setPointerCapture(e.pointerId);
        e.preventDefault();
        e.stopPropagation();
      });

      window.addEventListener('pointermove', (e) => {
        if (!draggingThumb) return;
        const dx = e.clientX - thumbStartX;
        syncScrollFromThumbLeft(thumbStartLeft + dx);
      });

      window.addEventListener('pointerup', () => {
        draggingThumb = false;
      });

      window.addEventListener('pointercancel', () => {
        draggingThumb = false;
      });

      track.addEventListener('pointerdown', (e) => {
        if (e.target === thumb) return;
        if (stepsTrack.scrollWidth <= stepsTrack.clientWidth + 1) return;

        const rect = track.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const thumbWidth = thumb.offsetWidth;
        syncScrollFromThumbLeft(x - thumbWidth / 2);
      });

      slider.addEventListener('bhtu:steps-update', () => {
        requestAnimationFrame(updateScrollbar);
      });

      if ('ResizeObserver' in window) {
        const ro = new ResizeObserver(() => updateScrollbar());
        ro.observe(stepsTrack);
        ro.observe(track);
      }

      requestAnimationFrame(updateScrollbar);
    });
  }

  function initVideos(root) {
    const videoWraps = root.querySelectorAll('[data-bhtu-video]');

    const pauseOtherVideos = (currentWrap) => {
      videoWraps.forEach((wrap) => {
        if (wrap === currentWrap) return;

        const video = wrap.querySelector('.bhtu__video-el');
        const button = wrap.querySelector('.bhtu__video-toggle');

        if (!video) return;

        if (wrap._bhtuHideTimer) {
          clearTimeout(wrap._bhtuHideTimer);
          wrap._bhtuHideTimer = null;
        }

        video.pause();
        wrap.classList.remove('is-playing', 'is-ui-hidden');

        if (button) {
          button.setAttribute('aria-label', 'Play video');
        }
      });
    };

    videoWraps.forEach((wrap) => {
      if (wrap.dataset.bound === 'true') return;
      wrap.dataset.bound = 'true';

      const video = wrap.querySelector('.bhtu__video-el');
      const button = wrap.querySelector('.bhtu__video-toggle');

      if (!video || !button) return;

      const clearHideTimer = () => {
        if (wrap._bhtuHideTimer) {
          clearTimeout(wrap._bhtuHideTimer);
          wrap._bhtuHideTimer = null;
        }
      };

      const scheduleHideUi = () => {
        clearHideTimer();
        wrap._bhtuHideTimer = window.setTimeout(() => {
          if (!video.paused && !video.ended) {
            wrap.classList.add('is-ui-hidden');
          }
        }, 1400);
      };

      const sync = () => {
        const isPlaying = !video.paused && !video.ended;
        wrap.classList.toggle('is-playing', isPlaying);
        wrap.classList.add('is-ready');
        button.setAttribute('aria-label', isPlaying ? 'Pause video' : 'Play video');

        if (isPlaying) {
          wrap.classList.remove('is-ui-hidden');
          scheduleHideUi();
        } else {
          clearHideTimer();
          wrap.classList.remove('is-ui-hidden');
        }
      };

      const preparePreviewFrame = () => {
        if (video.dataset.previewReady === 'true') {
          wrap.classList.add('is-ready');
          return;
        }

        const markReady = () => {
          video.dataset.previewReady = 'true';
          wrap.classList.add('is-ready');
          sync();
        };

        const primeFrame = () => {
          if (video.dataset.previewReady === 'true') return;

          try {
            const previewTime = video.duration && video.duration > 0.08 ? 0.08 : 0;

            if (previewTime === 0) {
              markReady();
              return;
            }

            const onSeeked = () => {
              video.pause();
              video.removeEventListener('seeked', onSeeked);
              markReady();
            };

            video.addEventListener('seeked', onSeeked, { once: true });
            video.currentTime = previewTime;
          } catch (error) {
            markReady();
          }
        };

        if (video.readyState >= 2) {
          primeFrame();
        } else {
          video.addEventListener('loadeddata', primeFrame, { once: true });
        }
      };

      const toggleVideo = () => {
        if (video.paused) {
          pauseOtherVideos(wrap);

          if (video.dataset.hasStarted !== 'true') {
            try {
              video.currentTime = 0;
            } catch (error) {}
          }

          const playPromise = video.play();

          if (playPromise && typeof playPromise.then === 'function') {
            playPromise
              .then(() => {
                video.dataset.hasStarted = 'true';
                sync();
              })
              .catch(() => {
                sync();
              });
          } else {
            video.dataset.hasStarted = 'true';
            sync();
          }
        } else {
          video.pause();
          sync();
        }
      };

      button.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        toggleVideo();
      });

      wrap.addEventListener('click', (event) => {
        if (event.target.closest('.bhtu__video-toggle')) return;
        toggleVideo();
      });

      video.addEventListener('play', sync);
      video.addEventListener('pause', sync);
      video.addEventListener('loadeddata', () => {
        wrap.classList.add('is-ready');
        sync();
      });
      video.addEventListener('ended', () => {
        clearHideTimer();
        wrap.classList.remove('is-ui-hidden');
        try {
          video.currentTime = 0;
        } catch (error) {}
        sync();
      });

      preparePreviewFrame();
      sync();
    });
  }

  function initFaq(root) {
    const faqGroups = root.querySelectorAll('[data-bhtu-faq]');

    faqGroups.forEach((faq) => {
      if (faq.dataset.bound === 'true') return;
      faq.dataset.bound = 'true';

      const faqItems = Array.from(faq.querySelectorAll('.bhtu__faq-item'));
      if (!faqItems.length) return;

      const getBody = (item) => item.querySelector('.bhtu__faq-body');
      const getHead = (item) => item.querySelector('.bhtu__faq-head');

      const syncAccordionHeights = () => {
        faqItems.forEach((item) => {
          const body = getBody(item);
          if (!body) return;
          body.style.setProperty('--bhtu-faq-body-h', `${body.scrollHeight}px`);
        });
      };

      const openItem = (item) => {
        item.classList.add('is-open');
        const head = getHead(item);
        if (head) head.setAttribute('aria-expanded', 'true');
      };

      const closeItem = (item) => {
        item.classList.remove('is-open');
        const head = getHead(item);
        if (head) head.setAttribute('aria-expanded', 'false');
      };

      faqItems.forEach((item) => {
        closeItem(item);
      });

      faq.addEventListener('bhtu:sync-heights', syncAccordionHeights);

      syncAccordionHeights();

      faqItems.forEach((item) => {
        const head = getHead(item);
        if (!head || head.dataset.bound === 'true') return;
        head.dataset.bound = 'true';

        head.addEventListener('click', () => {
          syncAccordionHeights();

          const isOpen = item.classList.contains('is-open');

          faqItems.forEach((other) => closeItem(other));
          if (!isOpen) openItem(item);

          requestAnimationFrame(syncAccordionHeights);
        });
      });

      window.addEventListener('resize', syncAccordionHeights);

      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(syncAccordionHeights).catch(() => {});
      }

      if ('ResizeObserver' in window) {
        const ro = new ResizeObserver(() => syncAccordionHeights());
        faqItems.forEach((item) => {
          const body = getBody(item);
          if (body) ro.observe(body);
        });
      }
    });
  }
});